import HereMapComponent from "../components/Map";
import React, { useState, useEffect } from 'react';
import { LuHouse, LuTrophy, LuLogIn } from 'react-icons/lu';
import "../styles/css/HomePage.css";
import { Link } from "react-router-dom";
import logo from '../styles/images/favicon-sans-fond.png';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import screenshot from "../styles/images/screenshot-2.png";

function Home() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const auth = getAuth();
    const unsub = onAuthStateChanged(auth, (user) => {
      setIsLoggedIn(!!user);
    });
    return () => unsub();
  }, []);

  // ── Carte étape réutilisable ──────────────────────────────────────────────
  const CarteEtape = ({ num, emoji, titre, texte, couleur, bg, footer }) => (
    <div style={{
      background: bg, border: `2px solid ${couleur}`,
      borderRadius: '16px', padding: '20px 16px',
      textAlign: 'center',
      boxShadow: `0 4px 16px ${couleur}20`,
    }}>
      <div style={{
        width: '32px', height: '32px', borderRadius: '50%',
        background: couleur, color: '#fff',
        fontWeight: 700, fontSize: '0.95rem',
        display: 'flex', alignItems: 'center',
        justifyContent: 'center', margin: '0 auto 12px',
      }}>{num}</div>
      <div style={{ fontSize: '2.2rem', marginBottom: '10px' }}>{emoji}</div>
      <h6 style={{ fontWeight: 700, color: couleur, marginBottom: '8px', fontSize: '0.95rem' }}>
        {titre}
      </h6>
      <p style={{ color: '#555', fontSize: '0.82rem', margin: 0, lineHeight: 1.6 }}>
        {texte}
      </p>
      <div style={{ margin: '12px auto 0', width: '36px', height: '3px', background: couleur, borderRadius: '2px' }} />
      <p style={{ color: couleur, fontSize: '0.78rem', fontWeight: 600, marginTop: '8px', marginBottom: 0 }}>
        {footer}
      </p>
    </div>
  );

  const etapes = [
    {
      num: 1, emoji: '🔓',
      titre: 'Signalez votre départ',
      texte: 'Cliquez sur "Libérer ma place" quand vous partez. Tous les utilisateurs voient instantanément les places disponibles.',
      couleur: '#07a993', bg: 'linear-gradient(135deg, #e8f8f5, #f0fdf9)',
      footer: 'Gagnez des points 🎁',
    },
    {
      num: 2, emoji: '🅿️',
      titre: 'Trouvez une place en 1 clic',
      texte: 'Cliquez sur "Trouver une place" pour voir toutes les places disponibles autour de vous sur la carte.',
      couleur: '#8b5cf6', bg: 'linear-gradient(135deg, #f3e8ff, #faf0ff)',
      footer: 'Temps réel ⚡',
    },
    {
      num: 3, emoji: '📡',
      titre: "Naviguez directement via l'app",
      texte: "Sélectionnez une place et laissez-vous guider directement jusqu'à votre destination sans quitter l'application.",
      couleur: '#0d6efd', bg: 'linear-gradient(135deg, #e8f0fe, #f0f4ff)',
      footer: 'GPS intégré 🗺️',
    },
  ];

  // ══════════════════════════════════════════════════════════════════════════
  // VUE CONNECTÉE — Hero épuré + carte uniquement
  // ══════════════════════════════════════════════════════════════════════════
  if (isLoggedIn) {
    return (
      <div>
        {/* ── Hero épuré sans bouton inscription ──────────────────────────── */}
        <header className="home-img" style={{
          textAlign: 'center',
          padding: 'clamp(24px, 6vw, 48px) 16px',
          display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
        }}>
          <h1 style={{ fontSize: 'clamp(1.4rem, 6vw, 2.8rem)', fontWeight: 700, marginBottom: '8px' }}>
            Bienvenue sur SpotyPark
          </h1>
          <h4 style={{
            fontSize: 'clamp(0.95rem, 3.5vw, 1.4rem)',
            fontWeight: 700, margin: 0,
            backgroundColor: 'rgba(235, 229, 206, 0.3)',
          }}>
            No stress — Take a place
          </h4>
        </header>

        {/* ── Carte HERE Maps ──────────────────────────────────────────────── */}
        <div style={{ margin: 'clamp(16px, 4vw, 32px) 0', padding: '0 clamp(8px, 3vw, 24px)' }}>
          <div style={{ borderRadius: '16px', overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.12)' }}>
            <HereMapComponent />
          </div>
        </div>
      </div>
    );
  }

  // ══════════════════════════════════════════════════════════════════════════
  // VUE NON CONNECTÉE — Page complète
  // ══════════════════════════════════════════════════════════════════════════
  return (
    <div>

      {/* ── Hero ──────────────────────────────────────────────────────────── */}
      <header className="home-img" style={{
        textAlign: 'center',
        padding: 'clamp(40px, 10vw, 100px) 16px',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
      }}>
        <h1 style={{ fontSize: 'clamp(1.6rem, 7vw, 3.2rem)', fontWeight: 700, marginBottom: '12px' }}>
          Bienvenue sur SpotyPark
        </h1>
        <h4 style={{
          fontSize: 'clamp(1rem, 4vw, 1.5rem)',
          fontWeight: 700, marginBottom: '8px',
          backgroundColor: 'rgba(235, 229, 206, 0.3)',
        }}>
          No stress — Take a place
        </h4>
        <p style={{
          fontSize: 'clamp(0.88rem, 3vw, 1.1rem)',
          marginBottom: '24px', maxWidth: '480px',
          fontWeight: 'bold',
          backgroundColor: 'rgba(235, 229, 206, 0.5)',
        }}>
          Votre solution de stationnement simple et rapide
        </p>
        <Link to="/inscription" className="btn btn-dark"
          style={{ padding: '12px 40px', fontSize: 'clamp(0.95rem, 3vw, 1.1rem)', fontWeight: 700, borderRadius: '10px' }}>
          Inscription
        </Link>
      </header>

      {/* ── Comment ça marche ─────────────────────────────────────────────── */}
      <div style={{ margin: 'clamp(24px, 6vw, 48px) 0', padding: '0 clamp(8px, 3vw, 24px)' }}>
        <h2 style={{ textAlign: 'center', fontWeight: 700, fontSize: 'clamp(1.2rem, 4vw, 1.8rem)', marginBottom: '8px' }}>
          Comment ça marche ?
        </h2>
        <p style={{ textAlign: 'center', color: '#6c757d', fontSize: '0.92rem', marginBottom: '28px' }}>
          Connectez-vous pour accéder à toutes les fonctionnalités
        </p>

        <div className="container px-2 px-md-3">
          <div className="row g-3 align-items-center">

            {/* Screenshot desktop */}
            <div className="col-12 col-md-6 d-none d-md-flex align-items-center justify-content-center">
              <img src={screenshot} alt="Interface SpotyPark"
                style={{
                  width: '100%', maxWidth: '420px', borderRadius: '16px',
                  boxShadow: '0 12px 40px rgba(0,0,0,0.18)', border: '3px solid #fff',
                }}
              />
            </div>

            {/* Étapes */}
            <div className="col-12 col-md-6 d-flex flex-column gap-3">
              {etapes.map((e) => (
                <CarteEtape key={e.num} {...e} />
              ))}
            </div>

            {/* Screenshot mobile */}
            <div className="col-12 d-md-none">
              <img src={screenshot} alt="Interface SpotyPark"
                style={{
                  width: '100%', borderRadius: '16px',
                  boxShadow: '0 8px 24px rgba(0,0,0,0.15)', border: '2px solid #dee2e6',
                }}
              />
            </div>

          </div>
        </div>
      </div>

      {/* ── Nos Services ──────────────────────────────────────────────────── */}
      {/* <div style={{ padding: 'clamp(24px, 6vw, 48px) clamp(12px, 4vw, 24px)', maxWidth: '1000px', margin: '0 auto' }}>
        <h2 style={{ textAlign: 'center', fontSize: 'clamp(1.2rem, 4vw, 1.8rem)', fontWeight: 700, marginBottom: '24px' }}>
          Nos Services
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '16px' }}>
          {[
            { icon: <MapPin size={32} color="#07a993" />, titre: 'Réservation de place', texte: 'Réservez votre place en quelques clics.',           lien: '/reservation-guide' },
            { icon: <Star   size={32} color="#0d6efd" />, titre: 'Suivi en temps réel',  texte: 'Suivez la disponibilité des places en temps réel.', lien: '/suivi-guide'       },
            { icon: <Shield size={32} color="#198754" />, titre: 'Paiement sécurisé',    texte: 'Payez directement en ligne de manière sécurisée.',  lien: '/paiement-guide'   },
          ].map(({ icon, titre, texte, lien }) => (
            <div key={titre} style={{
              background: '#fff', borderRadius: '12px', border: '1px solid #dee2e6',
              padding: '24px 20px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
              display: 'flex', flexDirection: 'column', gap: '10px',
            }}>
              <div>{icon}</div>
              <h5 style={{ fontWeight: 700, fontSize: '1rem', margin: 0 }}>{titre}</h5>
              <p style={{ fontSize: '0.88rem', color: '#6c757d', margin: 0, flex: 1 }}>{texte}</p>
              <Link to={lien} className="btn btn-primary btn-sm" style={{ alignSelf: 'flex-start', padding: '8px 16px' }}>
                En savoir plus
              </Link>
            </div>
          ))}
        </div>
      </div> */}

      {/* ── Pourquoi SpotyPark ────────────────────────────────────────────── */}
      <div style={{ background: '#f8f9fa', padding: 'clamp(24px, 6vw, 48px) clamp(12px, 4vw, 24px)' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <h2 style={{ textAlign: 'center', fontSize: 'clamp(1.2rem, 4vw, 1.8rem)', fontWeight: 700, marginBottom: '24px' }}>
            Pourquoi SpotyPark ?
          </h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
            {[
              { icon: <LuHouse size={36} color="#07a993" />, titre: 'Pratique', texte: 'Trouvez une place de parking rapidement et facilement grâce à notre plateforme.' },
              { icon: <LuTrophy size={36} color="#ffc107" />, titre: 'Récompenses', texte: 'Gagnez des récompenses pour chaque signalement de parking effectué.' },
              { icon: <LuLogIn size={36} color="#0d6efd" />, titre: 'Sécurisé', texte: "Profitez d'une expérience d'utilisation totalement sécurisée." },
            ].map(({ icon, titre, texte }) => (
              <div key={titre} style={{
                background: '#fff', borderRadius: '12px', border: '1px solid #dee2e6',
                padding: '24px 20px', textAlign: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
              }}>
                <div style={{ marginBottom: '12px' }}>{icon}</div>
                <h5 style={{ fontWeight: 700, fontSize: '1rem', marginBottom: '8px' }}>{titre}</h5>
                <p style={{ fontSize: '0.88rem', color: '#6c757d', margin: 0 }}>{texte}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── Stats rapides ─────────────────────────────────────────────────── */}
      <div style={{ padding: 'clamp(24px, 6vw, 40px) clamp(12px, 4vw, 24px)', maxWidth: '1000px', margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))', gap: '12px', textAlign: 'center' }}>
          {[
            { chiffre: '100', unite: 'Pionniers', icon: '🚀' },
            { chiffre: '100%', unite: 'Gratuit au lancement', icon: '🎁' },
            { chiffre: '24/7', unite: 'Disponible', icon: '🕐' },
            { chiffre: '< 2s', unite: 'Temps de réponse', icon: '⚡' },
          ].map(({ chiffre, unite, icon }) => (
            <div key={unite} style={{ background: '#e8f8f5', border: '1px solid #07a993', borderRadius: '12px', padding: '16px 8px' }}>
              <div style={{ fontSize: '1.4rem', marginBottom: '4px' }}>{icon}</div>
              <div style={{ fontSize: 'clamp(1.2rem, 5vw, 1.8rem)', fontWeight: 700, color: '#07a993' }}>{chiffre}</div>
              <div style={{ fontSize: '0.75rem', color: '#6c757d', marginTop: '4px' }}>{unite}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ── CTA final ─────────────────────────────────────────────────────── */}
      <div style={{
        background: '#1a1a2e', color: '#fff', textAlign: 'center',
        padding: 'clamp(40px, 8vw, 80px) 16px',
        marginTop: 'clamp(24px, 6vw, 48px)',
      }}>
        <div style={{
          width: 'clamp(60px, 15vw, 100px)', height: 'clamp(60px, 15vw, 100px)',
          borderRadius: '50%', background: 'rgba(7,169,147,0.15)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 20px',
        }}>
          <img src={logo} alt="logo spotypark" className="img-fluid object-fit-cover" />
        </div>
        <h2 style={{ fontSize: 'clamp(1.3rem, 5vw, 2.2rem)', fontWeight: 700, marginBottom: '12px' }}>
          Prêt à commencer ?
        </h2>
        <p style={{ fontSize: 'clamp(0.88rem, 3vw, 1.1rem)', opacity: 0.85, maxWidth: '400px', margin: '0 auto 24px' }}>
          Rejoignez SpotyPark et trouvez votre place maintenant !
        </p>
        <Link to="/inscription" className="btn btn-light"
          style={{ padding: '12px 40px', fontSize: 'clamp(0.95rem, 3vw, 1.1rem)', fontWeight: 700, borderRadius: '10px', color: '#07a993' }}>
          S'inscrire gratuitement
        </Link>
      </div>

    </div>
  );
}

export default Home;